import { Column } from "./dataTable.common";
import React from "react";
import _ from "lodash";
import { CheckBox } from "./checkBox2";
import { safebind } from "../helpers";

interface ColumnSelectorProps<T> {
    columns: Column<T>[],
    hiddenCols: string[]
    onChangeSelection: (column: Column<T>, hidden: boolean) => void
}


export class ColumnSelector<T> extends React.PureComponent<ColumnSelectorProps<T>> {
    private button = React.createRef<HTMLDivElement>();
    private dropdown = React.createRef<HTMLDivElement>();

    componentDidMount() {
        document.addEventListener("click", this.close);
    }

    private onSelectColumn = (column: Column<T>, checked: boolean) => {
        this.props.onChangeSelection(column, !checked)
    }

    private getColumnsCheck = (columns: Column<T>[], hiddenCols: string[]) => {
        return columns.filter((x) => x.canHide()).map(x => {
            const name = x.props.header as string;
            const title = x.props.title || name;
            const hidden = hiddenCols.indexOf(name) >= 0;
            return (<div className="m-1" key={`colSelector${name}`}>
                <CheckBox
                    name={`colSelector${name}`}
                    className="text-truncate d-inline-block"
                    title={title}
                    label={name}
                    checked={!hidden}
                    onChange={safebind(this.onSelectColumn, this, x)}
                />
            </div>);
        })
    }

    private toggle = (event: React.MouseEvent<HTMLButtonElement, MouseEvent> | null) => {
        const open = this.button.current!.classList.toggle("show");
        this.dropdown.current!.classList.toggle("show");
        this.button.current!.firstElementChild?.setAttribute("aria-expanded", open.toString())
        event?.nativeEvent.stopImmediatePropagation();
        event?.stopPropagation();
    }

    private close = (ev: MouseEvent) => {
        if (this.button != null) {
            const open = this.button.current?.firstElementChild?.getAttribute("aria-expanded");
            const isopen = open === "true";

            if (isopen)
                this.toggle(null)
        }
    }

    render() {
        const style = this.props.hiddenCols.length > 0 ? "btn-outline-primary" : "btn-outline-secondary";

        return (<div className="mx-1" ref={this.button}>
            <button
                type="button"
                className={`btn dropdown-toggle btn-sm border-0 ${style}`}
                aria-haspopup="true"
                aria-expanded="false"
                title="Seleziona colonne"
                onClick={this.toggle}
            >
                <i className="fa fa-filter" />
            </button>
            <div className="dropdown-menu dropdown-menu-end" ref={this.dropdown}>
                <div className="p-1" style={{ maxHeight: 400, width: 200, overflowY: "auto", overflowX: "hidden" }}>
                    <div className="">
                        {this.getColumnsCheck(this.props.columns, this.props.hiddenCols)}
                    </div>
                </div>
                <div className="dropdown-divider"></div>
                <button className="btn btn-primary float-end m-1 btn-sm" onClick={this.toggle}>Ok</button>
            </div>
        </div>)
    }
}